import PropTypes from 'prop-types';

export const propTypes = {
  align: PropTypes.oneOf([
    'center',
    'left',
    'right',
  ]),

  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
};

export const defaultProps = {
  align: 'left',
  marginTop: undefined,
  marginBottom: undefined,
};



// WEBPACK FOOTER //
// ./src/components/typography/types.js